// extracted by mini-css-extract-plugin
export default {"section":"Main_section__9jHGI","container":"Main_container__GDsLG","title":"Main_title__TLaQC","info":"Main_info__6sHMp","form":"Main_form__eIs-x","preview":"Main_preview__1HooV"};